import { render, staticRenderFns } from "./DeveloperEventProcessors.vue?vue&type=template&id=15bf4be2"
import script from "./DeveloperEventProcessors.vue?vue&type=script&lang=js"
export * from "./DeveloperEventProcessors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports